import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Layout from "./pages/Layout";
import NoPage from "./pages/NoPage";
import Dashboard from "./pages/Dashboard";
import UserControl from "./pages/UserControl";
import ExternalConsentForm from "./consent/external-consent-form";

import NewConsentFormPage from "./consent/NewConsentFormPage";


import { TokenHandler, useAuth } from "./components/TokenHandler";

// Initialize OpenTelemetry
//import './otel';

// Load runtime config if not already loaded
/* eslint-disable no-undef */
if (typeof window.APP_CONFIG === 'undefined' && typeof APP_CONFIG !== 'undefined') {
  window.APP_CONFIG = APP_CONFIG;
}
/* eslint-enable no-undef */

/**
 * PROTECTED app routes only (TokenHandler wraps this)
 */
function ProtectedApp() {
    const { roles } = useAuth();

    const hasAdminAccess = roles.includes("admin_role");
    const [selectedAction, setSelectedAction] = useState("Monthly check in");

    return (
        <Routes>
            <Route
                path="/"
                element={<Layout selectedAction={selectedAction} setSelectedAction={setSelectedAction} />}
            >
                <Route
                    index
                    element={<Dashboard selectedAction={selectedAction} setSelectedAction={setSelectedAction} />}
                />
                <Route
                    path="dashboard"
                    element={<Dashboard selectedAction={selectedAction} setSelectedAction={setSelectedAction} />}
                />
                <Route
                    path="UserControl"
                    element={hasAdminAccess ? <UserControl /> : <Navigate to="/" replace />}
                />
                <Route path="*" element={<NoPage />} />
            </Route>
        </Routes>
    );
}

/**
 * Root router: public routes live outside TokenHandler
 */
function RootRouter() {
    return (
        <BrowserRouter>
            <Routes>
                {/* PUBLIC (no Keycloak) */}
                <Route path="/consent/external-consent-form/fui/:facilityUniqueId" element={<NewConsentFormPage />} />
                <Route path="/consent/external-consent-form/:facilityCode" element={<NewConsentFormPage />} />
                <Route path="/consent/external-consent-form/" element={<NewConsentFormPage />} />
                {/* PROTECTED (Keycloak applies here) */}
                <Route
                    path="/*"
                    element={
                        <TokenHandler>
                            <ProtectedApp />
                        </TokenHandler>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootRouter />);